(function () {
  'use strict';

  /* @ngdoc object
   * @name parcels
   * @description
   *
   */
  angular
    .module('auth.registration', [
      'ui.router'
    ]);
}());
